import { render } from "./DisplayResources.vue?vue&type=template&id=67eb545b"
import script from "./DisplayResources.vue?vue&type=script&lang=js"
export * from "./DisplayResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/DisplayResources.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67eb545b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67eb545b', __exports__)) {
    api.reload('67eb545b', __exports__)
  }
  
  module.hot.accept("./DisplayResources.vue?vue&type=template&id=67eb545b", () => {
    api.rerender('67eb545b', render)
  })

}


export default __exports__